(ns client-portal.client.voice-insights.sessions.views
  (:require [client-portal.client.layout :as l]
            [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.constants :as constants]
            [client-portal.client.voice-insights.shared :as vi.shared]
            [client-portal.client.voice-insights.sessions.drawer.views :as drawer-views]
            [client-portal.client.voice-insights.sessions.list.views :as list-views]
            [client-portal.client.voice-insights.sessions.charts.views :as charts-views]
            [client-portal.client.voice-insights.sessions.utterances.views :as utterances-views]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [client-portal.client.day-part-schedules.data :as day-part-schedules.d]
            [client-portal.client.voice-insights.items.data]
            [client-portal.client.voice-insights.tags.data :as tags.d]
            [shared.core.amelia-light.components.components :as alc]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [client-portal.client.vi.components.tag :as tag]
            [shared.core.account.data :as account.d]
            [clojure.string :as s]
            [shared.core.util :as util]))

(defn filter-pair-child [{:keys [parent-index index children-by-name duration-options]}]
  (let [filter-data @(re/subscribe [:sessions/filter-data-])
        child (-> (get filter-data parent-index)
                  :children
                  (get index))
        child-by (:by child)
        duration-child? (= child-by "duration")]
    [:div {:style {:display :flex
                   :flex-direction :column
                   :gap 8}}
     [:div {:style {:display :flex
                    :align-items :center
                    :gap 8}}
      [:div {:style {:display :flex
                     :flex-wrap :wrap
                     :align-items :center
                     :gap 6
                     :flex 1}}
       [:div {:style {:flex "1 0 170px"}}
        [alc/up-dropdown {:placeholder "Child Tag"
                          :value child-by
                          :on-change (fn [v]
                                       (re/dispatch [:sessions/update-filter-pair-child parent-index index :by v])
                                       (re/dispatch [:sessions/update-filter-pair-child parent-index index :condition
                                                     (or (:condition child) "include")])
                                       (re/dispatch [:sessions/update-filter-pair-child parent-index index :join
                                                     (or (:join child) "or")])
                                       (re/dispatch [:sessions/update-filter-pair-child parent-index index :value nil]))
                          :options (mapv (fn [[child-name _]]
                                           {:value child-name :text (tag/tag->display-name {:name child-name})})
                                         (sort children-by-name))}]]
       [:div {:style {:flex "1 0 110px"}}
        [alc/up-dropdown {:placeholder "Condition"
                          :value (:condition child)
                          :on-change #(re/dispatch [:sessions/update-filter-pair-child parent-index index :condition %])
                          :options [{:value "include" :text "Includes"}
                                    {:value "exclude" :text "Excludes"}]}]]
       [:div {:style {:flex "1 0 100px"}}
        [alc/up-dropdown {:placeholder (if duration-child? "Any Of" "Any / All")
                          :value (:join child)
                          :on-change #(re/dispatch [:sessions/update-filter-pair-child parent-index index :join %])
                          :options (filterv identity
                                            [{:value "or" :text "Any Of"}
                                             (when duration-child?
                                               {:value "and" :text "All Of"})])}]]
       [:div {:style {:flex "1 1 160px"}}
        [alc/up-multiple-dropdown
         {:placeholder (str "Select " (or (when child-by
                                            (tag/tag->display-name {:name child-by}))
                                          "Value"))
          :form-path (conj sessions.d/filter-data-path parent-index :children index)
          :form-name :value
          :options (if duration-child?
                     (mapv (fn [opt]
                             {:value (util/->kebab-case-string opt)
                              :text (:name opt)})
                           duration-options)
                     (->> (get children-by-name child-by)
                          (mapv (fn [opt]
                                  {:text (tag/tag->display-name {:value (:value opt)})
                                   :value (:value opt)}))
                          (distinct)
                          (sort-by :text)))}]]]
      [:div {:style {:flex "0 0 auto"
                     :display :flex
                     :align-items :center}}
       [alc/up-ghost-button {:icon-type :CrossIcon
                             :on-click #(re/dispatch [:sessions/remove-filter-pair-child parent-index index])}]]]]))

(defn comparison-filter-entries [{:keys [index unit]}]
  (let [filter-data @(re/subscribe [:sessions/filter-data-])
        entry (or (first (:value (get filter-data index)))
                  sessions.d/default-comparison-entry)]
    [:div {:style {:display :flex
                   :align-items :center
                   :gap 6}}
     [:div {:style {:width 90}}
      [alc/up-dropdown {:placeholder "Op"
                        :value (:op entry)
                        :on-change #(re/dispatch [:sessions/update-comparison-entry index 0 :op %])
                        :options sessions.d/comparison-operator-options}]]
     [:div {:style {:flex 1}}
      [alc/up-input {:placeholder (or unit "Value")
                     :form-path (conj sessions.d/filter-data-path index :value 0)
                     :form-name :value
                     :regex #"\d*"}]]]))

(defn filter-pair [{:keys [index]}]
  (let [filter-data @(re/subscribe [:sessions/filter-data-])
        roles @(re/subscribe [:account/user-roles-])
        filter-pair (get filter-data index)
        filter-by (:by filter-pair)
        tags-data @(re/subscribe [:vi-tags/list-by-current-concept-id-])
        loading-tags? (util/loading? tags-data)
        tags (tags.d/all-tags tags-data)
        enums (:enums (util/when-not-loading tags-data))
        concept-day-parts (some->> (util/when-not-loading @(re/subscribe [:day-parts/by-current-concept-id-]))
                                   (day-part-schedules.d/concept-day-parts))
        comparison-options (mapv (fn [[value cfg]] {:value value :text (:text cfg)})
                                 sessions.d/comparison-filter-options)
        filter-by-options (->> (concat [{:value "tags" :text "Tags"}
                                        {:value "day-of-week" :text "Day of Week"}
                                        {:value "time-of-day" :text "Time of Day"}
                                        (when (seq concept-day-parts)
                                          {:value "day-part" :text "Day Part"})
                                        {:value "duration" :text "Duration"}]
                                       comparison-options)
                               (filterv identity))
        filter-by-tags? (= filter-by "tags")
        comparison-filter? (sessions.d/comparison-filter? filter-by)
        any-only? (contains? #{"day-of-week" "time-of-day" "day-part" "duration"} filter-by)
        filter-by-text (->> filter-by-options
                            (filter #(= (:value %) filter-by))
                            (first)
                            :text)
        duration-options (concat
                           (mapv (fn [[start end]]
                                   {:name (str start "-" end " seconds")
                                    :value {:unit "second" :start start :end end}})
                                 [[0 30] [30 60] [60 90] [90 120]])
                           (mapv (fn [[start end]]
                                   {:name (str start (if end (str "-" end) "+") " minutes")
                                    :value {:unit "minute" :start start :end end}})
                                 [[2 3] [3 nil]]))
        selected-tag-items (when filter-by-tags?
                             (some->> (:value filter-pair)
                                      (mapv #(let [t (util/->kebab-case-keywords %)]
                                               (vector (:name t) (:value t))))
                                      (into #{})))
        selected-tag-names (some->> selected-tag-items (map first) (into #{}))
        tag-children (when (and (not-empty selected-tag-items) (not loading-tags?))
                       (->> tags
                            (filter #(contains? selected-tag-names (:name %)))
                            (mapcat #(tags.d/tag-children->options enums (:children %)))
                            (distinct)))
        children-by-name (when tag-children (group-by :name tag-children))
        selected-tag-children (when (not-empty tag-children)
                                (if (empty? (:children filter-pair))
                                  [sessions.d/default-filter-pair-child]
                                  (:children filter-pair)))
        child-tags? (and filter-by-tags? (not-empty selected-tag-items) (not-empty selected-tag-children))]
    [:div {:style {:display :flex
                   :align-items :center
                   :gap 8
                   :width "100%"}}
     [alc/card {:title (str "Filter " (inc index))
                :title-inline-contents [[c/spacer]
                                        [alc/up-button {:icon-type :DeleteIcon
                                                        :on-click #(re/dispatch [:sessions/delete-filter-data-index index])}]
                                        (when child-tags?
                                          [alc/up-button {:icon-type :AddIcon
                                                          :on-click #(re/dispatch [:sessions/add-filter-pair-child index])}
                                           "Add Child Tag"])]
                :style {:gap 8
                        :padding "8px 16px 16px"}}
      [:div {:style {:display :flex
                     :flex-wrap :wrap
                     :align-items :center
                     :gap 6}}
       [:div {:style {:flex "1 0 190px"}}
        [alc/up-dropdown {:placeholder "Filter by"
                          :value (:by filter-pair)
                          :on-change (fn [v]
                                       (re/dispatch [:sessions/update-filter-pair index :by v])
                                       (re/dispatch [:sessions/update-filter-pair index :value
                                                     (when (sessions.d/comparison-filter? v)
                                                       [sessions.d/default-comparison-entry])])
                                       (re/dispatch [:sessions/update-filter-pair index :children []]))
                          :options filter-by-options}]]
       (when-not comparison-filter?
         [:div {:style {:flex "1 0 110px"}}
          [alc/up-dropdown {:placeholder "Condition"
                            :value (:condition filter-pair)
                            :on-change #(re/dispatch [:sessions/update-filter-pair index :condition %])
                            :options [{:value "include" :text "Includes"}
                                      {:value "exclude" :text "Excludes"}]}]])
       (when (and (not comparison-filter?)
                  (contains? #{"include" "exclude"} (:condition filter-pair)))
         [:div {:style {:flex "1 0 100px"}}
          [alc/up-dropdown {:placeholder (if any-only? "Any Of" "Any / All")
                            :value (:join filter-pair)
                            :on-change #(re/dispatch [:sessions/update-filter-pair index :join %])
                            :options (filterv identity
                                              [{:value "or" :text "Any Of"}
                                               (when-not any-only?
                                                 {:value "and" :text "All Of"})])}]])
       [:div {:style {:flex "1 1 160px"}}
        (cond
          comparison-filter?
          [comparison-filter-entries {:index index
                                      :unit (get-in sessions.d/comparison-filter-options [filter-by :unit])}]

          filter-by
          [alc/up-multiple-dropdown
           {:placeholder (str "Select " (or filter-by-text "Value"))
            :form-path (conj sessions.d/filter-data-path index)
            :form-name :value
            :options (mapv (fn [option]
                             {:value (util/->kebab-case-string option)
                              :text (if filter-by-tags?
                                      (tag/tag->display-name option)
                                      (:name option))})
                           (cond
                             filter-by-tags?
                             (->> (tags.d/tags->name-value-pairs tags)
                                  (sort-by tag/tag->display-name)
                                  (filterv (fn [t]
                                             (let [required-roles (get tag.d/tag-name-roles (:name t))]
                                               (and (or (empty? required-roles)
                                                        (account.d/has-roles-access? roles required-roles))
                                                    (not (contains? tag.d/tags-names-to-remove-from-sessions-filter
                                                                    (:name t)))))))
                                  (mapv #(select-keys % [:name :value])))

                             (= filter-by "day-of-week")
                             (mapv #(hash-map :name % :value %) constants/days-of-the-week)

                             (= filter-by "time-of-day")
                             (mapv #(hash-map :name %
                                              :value (util/time-of-day-with-leading-zero %))
                                   constants/hours-of-day)

                             (= filter-by "day-part")
                             (mapv #(hash-map :name (util/->capitalize-words (:label %))
                                              :value (:label %))
                                   concept-day-parts)

                             (= filter-by "duration")
                             duration-options

                             :else
                             []))}])]]
      (when child-tags?
        (into [:div {:style {:display :flex
                             :flex-direction :column
                             :gap 8}}]
              (map-indexed (fn [child-idx _]
                             [filter-pair-child {:parent-index index
                                                 :index child-idx
                                                 :children-by-name children-by-name
                                                 :duration-options duration-options}])
                           selected-tag-children)))]]))

(defn filter-popover []
  (let [filter-data @(re/subscribe [:sessions/filter-data-])]
    [:div {:style {:background-color (style/alc-color "Background/up_level")
                   :border (str "1px solid " (style/alc-color "Border/divider_secondary"))
                   :border-radius 6
                   :box-shadow (style/alc-shadow "shadow/common_overlay")
                   :z-index 49
                   :padding 12
                   :display :flex
                   :flex-direction :column
                   :gap 12
                   :width 650
                   :max-width "calc(100vw - 32px)"}}
     [:div {:style {:display :flex
                    :align-items :center
                    :justify-content :space-between}}
      [:span {:style {:font-size 20
                      :font-weight 400
                      :line-height 1.4
                      :color (style/alc-color "Text/primary_header")}}
       "Filter"]
      [alc/up-button {:icon-type :AddIcon
                      :on-click #(re/dispatch [:sessions/add-filter-pair])}
       "Add New"]]
     [:div {:style {:display :flex
                    :flex-direction :column
                    :gap 8}}
      (into [:<>]
            (map-indexed (fn [idx _]
                           [filter-pair {:index idx}])
                         filter-data))]
     [:div {:style {:display :flex
                    :align-items :center
                    :gap 10}}
      [alc/up-button {:disabled (empty? (some->> filter-data (filter :value)))
                      :on-click #(do
                                   (re/dispatch [:sessions/close-filter-popover])
                                   (re/dispatch [:sessions/clear-filters]))}
       "Reset Filters"]
      [c/spacer]
      [alc/up-call-to-action-button {:on-click #(do
                                                  (re/dispatch [:sessions/close-filter-popover])
                                                  (re/dispatch [:sessions/apply-filters]))}
       "Apply"]]]))

(defn filter-button []
  (let [filter-data- (re/subscribe [:sessions/applied-filters-])
        admin?- (re/subscribe [:account/admin-role?-])
        filter-shown?- (re/subscribe [:sessions/filter-popover-open?-])
        tags-list- (re/subscribe [:vi-tags/list-by-current-concept-id-])]
    (fn []
      (let [filter-data @filter-data-
            filter-count (some->> filter-data (filter :value) (count))
            admin? @admin?-
            filter-shown? @filter-shown?-]
        [:div {:style {:flex "0 0 auto"
                       :display :flex
                       :gap 8}}
         (when (and admin? (some-> filter-count (pos?)))
           [alc/tooltip
            {:tooltip-content "Copy Filters JSON"
             :target-content [alc/up-button {:icon-type :CopyIcon
                                             :on-click #(re/dispatch [:core/copy-to-clipboard
                                                                      (util/map->json-string-min filter-data)
                                                                      {:notify? true}])}]}])
         [alc/up-popover
          {:open filter-shown?
           :on-open-change #(re/dispatch [:sessions/toggle-filter-popover %])
           :modal false
           :side :bottom
           :align :end
           :side-offset 8
           :collision-padding 16
           :class-name "w-auto p-0 border-0 bg-transparent shadow-none"
           :trigger [:span {:style {:display :inline-flex}}
                     [alc/up-button (cond-> {:id :add-filter-button
                                             :icon-type :FilterIcon
                                             :disabled (util/loading? @tags-list-)}
                                            filter-shown?
                                            (assoc :variant "togglePressed"))
                      (if (pos? filter-count)
                        (str filter-count " " (util/pluralize "Filter" filter-count))
                        "Add Filter")]]
           :content [filter-popover]}]]))))

(defn sessions-header
  []
  (let [sessions-count- (re/subscribe [:sessions/count-])]
    (fn []
      [:div {:style {:display :flex
                     :align-items :center
                     :justify-content :space-between}}
       [:span {:style {:color (style/alc-color "Text/primary_header")
                       :font-size 24
                       :font-weight 400
                       :line-height 1.33}}
        "Sessions"
        (when-not (util/loading? @sessions-count-)
          [:span {:style {:color (style/alc-color "Text/primary")
                          :margin-left 8}}
           (str "(" (some-> @sessions-count- (util/readable-number)) ")")])]])))

(defn sessions-toolbar []
  (let [selected-view-mode- (re/subscribe [:sessions/view-mode-])
        selected-mode (or @selected-view-mode- "sessions")
        admin?- (re/subscribe [:account/admin-role?-])
        qps- (re/subscribe [:router/current-query-params-])]
    [:div
     [:div {:style {:display :flex
                    :flex-wrap :wrap
                    :align-items :flex-end
                    :justify-content :space-between
                    :gap 8}}
      [:div {:style {:display :flex
                     :flex-direction :column
                     :max-width "100%"}}
       [alc/up-toggle-group
        {:type "single"
         :value selected-mode
         :style {:flex-wrap :wrap
                 :height :auto
                 :min-height 40
                 :max-width "100%"
                 :padding-top 3
                 :padding-bottom 3}
         :on-value-change (fn [v]
                            (when (seq v)
                              (re/dispatch [:voice-insights/scroll-to-top])
                              (re/dispatch [:sessions/select-view-mode v])))
         :items (mapv (fn [{:keys [mode icon-type icon-content label]}]
                        {:value mode
                         :content [:div {:style {:display :flex
                                                 :align-items :center
                                                 :gap 6}}
                                   (or icon-content
                                       [c/material-icon {:icon-type icon-type
                                                         :style {:font-size 16}}])
                                   [:span label]]})
                      [{:mode "sessions" :icon-type :forum :label "Sessions"}
                       {:mode "charts" :icon-type :timeline :label "Charts"}
                       {:mode "utterances"
                        :icon-content [utterances-views/utterance-icon {:color "currentColor"}]
                        :label "Utterances"}])}]]
      [:div {:style {:display :flex
                     :flex-wrap :wrap
                     :align-items :center
                     :gap 8}}
       [filter-button]
       (when @admin?-
         (let [search-convo-id (fn [e]
                                 (when-let [el (js/document.getElementById "convo-id-search-input")]
                                   (let [v (or (some-> e
                                                       (.-clipboardData)
                                                       (.getData "text/plain"))
                                               (.-value el))]
                                     (re/dispatch [:router/go-with-merged-query-params
                                                   {:conv (sessions.d/conversation->conv-qp
                                                            {:conversation-id v
                                                             :namespace (:ns @qps-)})}])
                                     (set! (.-value el) "")
                                     (.blur el))))]
           [alc/up-input {:id :convo-id-search-input
                          :class-name "w-60"
                          :placeholder "Search By Session ID"
                          :on-key-down #(when (util/enter-key-event? %)
                                          (search-convo-id %))
                          :on-paste search-convo-id}]))]]]))

(defn sessions-header-container []
  (let [container-id "sessions-header-container"
        view-mode- (re/subscribe [:sessions/view-mode-])
        vs- (re/subscribe [:core/viewport-size])
        filter-data- (re/subscribe [:sessions/applied-filters-])
        set-filter-height #(when-let [container-height (some-> (js/document.getElementById container-id)
                                                               (.getBoundingClientRect)
                                                               (.-height))]
                             (re/dispatch [:sessions/set-filter-container-height container-height]))
        resize-observer* (atom nil)]
    (re/create-class
      {:component-did-mount
       (fn []
         (set-filter-height)
         (when-let [el (js/document.getElementById container-id)]
           (reset! resize-observer* (js/ResizeObserver. set-filter-height))
           (.observe @resize-observer* el)))

       :component-will-unmount
       #(some-> @resize-observer* (.disconnect))

       :component-did-update
       set-filter-height

       :reagent-render
       (fn []
         @vs- @filter-data-
         [:div {:id container-id
                :style (cond-> {:background-color (style/alc-color "Background/card_hex")
                                :display :flex
                                :flex-direction :column
                                :gap 16
                                :padding "12px 16px 16px"
                                :top 0
                                :left 0
                                :z-index (inc (style/z :medium))}
                               (not= @view-mode- "charts")
                               (assoc :position :sticky))}
          [sessions-header]
          [sessions-toolbar]
          (when (some->> @filter-data- (filter :value) (not-empty))
            (into [:div {:style {:display :flex
                                 :align-items :center
                                 :flex-wrap :wrap
                                 :gap 8}}]
                  (concat (map-indexed (fn [idx {:keys [by condition join value children]}]
                                         (let [comparison? (sessions.d/comparison-filter? by)
                                               comparison-label (when comparison?
                                                                  (let [op->text (into {} (map (juxt :value :text) sessions.d/comparison-operator-options))
                                                                        unit-suffix (get-in sessions.d/comparison-filter-options [by :unit-suffix])]
                                                                    (str (get-in sessions.d/comparison-filter-options [by :text])
                                                                         " "
                                                                         (->> value
                                                                              (map #(str (op->text (get % "op")) " " (get % "value") unit-suffix))
                                                                              (s/join ", ")))))
                                               value-label (str "\"" (->> value
                                                                          (map #(if (= by "tags")
                                                                                  (tag/tag->display-name (util/->kebab-case-keywords %))
                                                                                  (get % "name")))
                                                                          (s/join ", "))
                                                                "\"")
                                               children-label (when (not-empty children)
                                                                (->> children
                                                                     (mapv (fn [child]
                                                                             (str "\""
                                                                                  (tag/tag->display-name {:name (:by child)})
                                                                                  "\""
                                                                                  " "
                                                                                  (-> (:condition child)
                                                                                      (util/pluralize 2)
                                                                                      (util/->capitalize-words))
                                                                                  " "
                                                                                  (str (if (= (:join child) "and")
                                                                                         "All Of"
                                                                                         "Any Of")
                                                                                       " ")
                                                                                  (str "\"" (->> (:value child)
                                                                                                 (map #(if (= (:by child) "duration")
                                                                                                         (:name %)
                                                                                                         (tag/tag->display-name {:value (util/->kebab-case-keywords %)})))
                                                                                                 (s/join ", "))
                                                                                       "\""))))
                                                                     (s/join " and ")))]
                                           [alc/up-tag {:selected true
                                                        :style {:height :auto
                                                                :min-height 36
                                                                :max-width "100%"
                                                                :flex-shrink 1
                                                                :white-space :normal}
                                                        :on-close (fn [_]
                                                                    (re/dispatch [:sessions/remove-filter-pair idx])
                                                                    (re/dispatch [:sessions/apply-filters]))}
                                            [:span {:style {:min-width 0
                                                            :overflow-wrap :anywhere}}
                                             (if comparison?
                                               comparison-label
                                               (str (util/->capitalize-words by)
                                                    " "
                                                    (-> condition
                                                        (util/pluralize 2)
                                                        (util/->capitalize-words))
                                                    " "
                                                    (when join
                                                      (str (if (= join "and")
                                                             "All Of"
                                                             "Any Of")
                                                           " "))
                                                    value-label
                                                    (when (and (= by "tags") children-label)
                                                      (str " and " children-label))))]]))
                                       @filter-data-)
                          [[alc/up-ghost-button {:on-click #(re/dispatch [:sessions/clear-filters])}
                            "Clear Filters"]])))])})))

(defn root [_]
  (let [view-mode- (re/subscribe [:sessions/view-mode-])
        cur-route- (re/subscribe [:router/current-route-])
        sessions- (re/subscribe [:sessions/list-flattened-])
        sessions-loading?- (re/subscribe [:sessions/list-loading?-])
        locations-by-concept-id- (re/subscribe [:locations/by-current-concept-id-])
        charts-list- (re/subscribe [:sessions/charts-list-])
        utterances-list- (re/subscribe [:sessions/utterances-list-])
        open-session-from-conv (fn [this]
                                 (when-let [conv (some-> (:conv (re/props this))
                                                         (sessions.d/conv-qp->conversation))]
                                   (re/dispatch [:sessions/toggle-drawer-open (assoc conv :open? true)])))]
    (re/create-class
      {:component-did-mount (fn [this]
                              (re/dispatch [:sessions/initialize])
                              (open-session-from-conv this))
       :component-did-update (fn [this]
                               (open-session-from-conv this))
       :reagent-render
       (fn [{:keys [_] :as args}]
         @charts-list- @utterances-list-                  ;; Preload other tab data
         (let [view-mode (or @view-mode- :sessions)
               sessions @sessions-
               sessions-loading? @sessions-loading?-
               locations-data @locations-by-concept-id-
               loading? (or sessions-loading? (util/loading? locations-data))]
           [l/logged-in-with-header-nav-vi
            (merge args {:concept-dropdown? true
                         :location-dropdown? true
                         :concept-dropdown-config
                         {:extra-on-change
                          (fn [value]
                            (let [cid (when (and value (not (s/blank? value)))
                                        (util/parse-int value))
                                  [route-name route-params route-query] @cur-route-
                                  base-query (or route-query {})
                                  next-query (-> base-query
                                                 (cond->
                                                   cid (assoc :cid cid)
                                                   (not cid) (dissoc :cid))
                                                 (dissoc :lid))]
                              (re/dispatch [:locations/clear-selected])
                              (re/dispatch [:router/go [route-name route-params next-query]
                                            {:on-route-change #(re/dispatch [:sessions/on-concept-change])}])))}
                         :location-dropdown-config {:extra-on-change #(re/dispatch [:sessions/reload-conversations-list])}})
            [:div {:style {:display :flex
                           :flex-direction :column
                           :width "100%"
                           :min-height "100%"}}
             [sessions-header-container]
             [:div {:style {:flex 1
                            :display :flex
                            :flex-direction :column
                            :padding "0 16px 12px"}}
              (cond
                (and (= view-mode "sessions") loading?) [empty-state/loading-sessions-card]
                (and (empty? sessions) (not loading?)) [empty-state/no-sessions-card]
                :else (case view-mode
                        "charts" [charts-views/charts-view]
                        "utterances" [utterances-views/utterances-view]
                        [list-views/sessions-list]))]]]))})))
